import type { z } from 'zod';

import { UUID } from './uuid';

export const DomainUserId = UUID;

export type DomainUserId = z.infer<typeof DomainUserId>;
